"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Fade.default;
  }
});

var _Fade = _interopRequireDefault(require("./Fade"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/Fade/index.js
 ** module id = 208
 ** module chunks = 0
 **/